import React, {Fragment} from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
const Comments_reply = (props) => {

    let link_post_get="/"+props.link_to;
    link_post_get=link_post_get.replaceAll("//","")


    return (
        <>



            {
                String(props.data_info_list).length==0 ?  (

                <Fragment></Fragment>

            ) : (
                <Fragment>


                    {

                        props.data_info_list.map((item_comment_curent,index) => {


                            return (
                                <Fragment>
                                    <div className="flexColStartStart w-100 sin-mu-com-wrapper box-reply-comments">


                                        <div className="flexRowBetStart w-100 sin-mu-com">
                                            <div className="flexRowBetCenter box-comment-section">
                                                <AccountCircleIcon style={{"fontSize":"56px","color":"#bebebe","marginLeft":"12px"}}/>
                                                <div className="flexColStartStart sin-mu-com-info">
                                                    <span style={{"display":"block","marginBottom":"10px","width":"100%","color":"#8BC34A","fontFamily":"iran"}}>پاسخ توسط : {item_comment_curent.first_and_last_name}</span>
                                                    <p  style={{"lineHeight":"1.6"}}>{item_comment_curent.description}</p>
                                                </div>


                                            </div>

                                            {/*<p>تاریخ : <span>{item_comment_curent.date_post_get}</span></p>*/}
                                        </div>


                                    </div>
                                </Fragment>

                            )

                        })

                    }




                </Fragment>

            ) }

        </>
    );

}
export default Comments_reply;

